<template>
  <svg
    id="a"
    data-name="Ebene 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 408.17 225.03"
  >
    <path d="M408.17,0H5C2.24,0,0,2.24,0,5v143.81c0,1.48.65,2.88,1.79,3.83l84.87,71.22c.9.76,2.04,1.17,3.21,1.17h318.3V0Z" style="fill: red;" />
    <polygon points="137.5 56.66 101.78 56.66 101.78 92.38 66.06 92.38 66.06 128.1 101.78 128.1 101.78 163.82 137.5 163.82 137.5 128.1 173.22 128.1 173.22 92.38 137.5 92.38 137.5 56.66" style="fill: #fff;" />
  </svg>
</template>
